import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { InformationModal } from '../InformationModal';
import promoteContributorSeatsImage from '../assets/promote_contributor_seats_popup.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'PromoteContributorSeats.headline',
    defaultMessage: 'Empower more people to analyze results',
    description:
      '[Type: Header][Vis.: low] - Promote contributor seats info modal headline',
  },
  SUB_HEADLINE: {
    id: 'PromoteContributorSeats.sub_headline',
    defaultMessage: 'Add Contributor seats to your plan',
    description:
      '[Type: Header][Vis.: low] - Promote contributor seats info modal sub headline',
  },
  MESSAGE: {
    id: 'PromoteContributorSeats.message',
    defaultMessage:
      'Customize your team to fit the way you work. Get stakeholders closer to your survey data by adding Contributor seats to your plan. Contributors can filter results, create dashboards, and export data — at a fraction of the cost of adding a Full User. You’ll pay only for the analysis features your contributor needs, and empower your team to make a bigger impact with data-driven decision making.',
    description:
      '[Type: Paragraph][Vis.: low] - Promote contributor seats info modal message',
  },
  DISMISS_CTA_TEXT: {
    id: 'PromoteContributorSeats.dismiss_cta_text',
    defaultMessage: 'NO THANKS',
    description:
      '[Type: Button][Vis.: low] - Promote contributor seats info modal dismiss cta',
  },
  PRIMARY_CTA_TEXT: {
    id: 'PromoteContributorSeats.primary_cta_text',
    defaultMessage: 'ADD CONTRIBUTORS',
    description:
      '[Type: Button][Vis.: low] - Promote contributor seats info modal primary cta',
  },
});

export const PromoteContributorSeats: React.FC = () => {
  return (
    <InformationModal
      headline={t(COPY.HEADLINE)}
      subHeadline={t(COPY.SUB_HEADLINE)}
      message={t(COPY.MESSAGE)}
      dismissCtaText={t(COPY.DISMISS_CTA_TEXT)}
      primaryCtaText={t(COPY.PRIMARY_CTA_TEXT)}
      primaryCtaLink="/team/add/?marketing=True"
      image={() => (
        <img src={promoteContributorSeatsImage} alt="" aria-hidden="true" />
      )}
    />
  );
};

export default PromoteContributorSeats;
